import { ref, provide, inject, computed } from 'vue'

const FORM_ERRORS_KEY = Symbol('formErrors')

export function useFormErrors() {
  const errors = ref({})

  const setErrors = (serverErrors) => {
    errors.value = serverErrors ?? {}
  }

  const clearErrors = () => {
    errors.value = {}
  }

  const clearField = (name) => {
    const copy = { ...errors.value }
    delete copy[name]
    errors.value = copy
  }

  provide(FORM_ERRORS_KEY, { errors, clearField })

  return { errors, setErrors, clearErrors, clearField }
}

export function useFieldErrors(name) {
  const context = inject(FORM_ERRORS_KEY, null)
  if (!context) return { fieldErrors: computed(() => []), clearFieldErrors: () => {} }

  const fieldErrors = computed(() => context.errors.value?.[name] ?? [])
  const clearFieldErrors = () => context.clearField(name)

  return { fieldErrors, clearFieldErrors }
}
